import getApiClient from '@/plugins/api'
const moment = require('moment')

export default {
  changePage: function (page) {
    this.page = page
  },

  loadPayables() {
    const self = this;
    const api = getApiClient(self.$root.$store);

    self.$store.commit('startLoading')

    self.searchParams.page = self.page
    self.searchParams.itemsPerPage = self.perPage
    self.searchParams['order.status'] = [3, 4, 6, 8];

    if (self.searchParams['paymentDate'] !== undefined) {
      delete self.searchParams['paymentDate']
      self.searchParams['paymentDate[after]'] = moment(new Date()).format('YYYY-MM-DD 00:00:00');
      self.searchParams['paymentDate[before]'] = moment(new Date()).format('YYYY-MM-DD 23:59:59');
    }

    if (self.searchParams['status'] !== undefined) {
      self.searchParams.status = 0
    }

    api.get('settings/comission_percent')
      .then(response => {
        self.commissionPercent = response.data.value

        api.get('agency_payables', {
          params: self.searchParams
        })
          .then((result) => {
            self.payables = result.data['hydra:member']
            self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.perPage)
          })
          .catch((error) => {
            console.log(error)
          })
          .finally(() => {
            self.$store.commit('stopLoading')
          })
      })
  },

  updatePayableStatus(event, payable) {
    const self = this
    const api = getApiClient(self.$root.$store)

    self.$store.commit('startLoading')

    payable.status = event
    api.patch(payable['@id'], {
      status: payable.status
    }, {
      headers: {
        'Content-Type': 'application/merge-patch+json'
      }
    })
      .then(() => {
        self.loadPayables()
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  addToClipboard(id) {
    const element = document.getElementById(id)
    element.select();
    element.setSelectionRange(0, 99999)
    navigator.clipboard.writeText(element.value);
  },

  setAgency: function(data) {
    this.searchParams['order.trip.agency.id'] = data.value
  },

  resetAgency: function() {
    this.searchParams['order.trip.agency.id'] = null
  },

  latestPixStatus: function(payable) {
    if (!payable.pix.length) {
      return null
    }

    return payable.pix[0].status
  },

  latestTransferStatus: function(payable) {
    if (!payable.pagarmeTransfers || !payable.pagarmeTransfers.length) {
      return null
    }

    return payable.pagarmeTransfers[0].status
  }
}
